
const toggleList = document.getElementById('toggle__list');
const toggleGrid = document.getElementById('toggle__grid');
const productGridContainer = document.querySelector('.product-grid-container');

const storedLayout = localStorage.getItem('layout');
    if (storedLayout) {
        productGridContainer.className = 'product-grid-container ' + storedLayout;
    }
function applyStoredLayout() {
    
}
toggleList.addEventListener('click', function() {
    productGridContainer.classList.remove('grid-view'); 
    productGridContainer.classList.add('list-view'); 
    localStorage.setItem('layout', 'list-view'); 
});

toggleGrid.addEventListener('click', function() {
    productGridContainer.classList.remove('list-view'); 
    productGridContainer.classList.add('grid-view'); 
    localStorage.setItem('layout', 'grid-view'); 
});
document.addEventListener('DOMContentLoaded', function() {
    applyStoredLayout(); 
});






